export default __webpack_public_path__ + "static/media/second-left.83fbe2eb.png";